
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
    TableContainer, styled,
    Table,
    TableBody,
    TableCell,

    TableHead,
    TableRow,
} from "@mui/material";
import { numberFormatter } from "../../../utils/formatter";

type Props = {
    enabled: boolean,
    opportunity: number,
    count: number,
    heading: Heading,
    selectedCustomerId: any,
    district?: string,
    isFilterExpanded: boolean
}

type MetaData = {
    url: string;
    headingValue: string;
    label: string;
    value: string
}

type Heading = "cts" | "crosssell" | "bci"

const getData: (heading: Heading, selectedCustomerId: string, count: number, opportunity: number, enabled: boolean, district?: string) => MetaData | undefined = (heading, selectedCustomerId, count, opportunity, enabled, district) => {
    const value = enabled ? `$${numberFormatter(opportunity, 1)}` : `-`;
    switch (heading) {
        case "crosssell":
            return { url: "/cross-sell?customer=" + selectedCustomerId, headingValue: "Cross Sell", label: enabled ? `Cross-sell other items that similar customers accross ${count} categories` : "-", value };
        case "cts":
            return { url: "/cts?district=" + district, headingValue: "Cost To Serve", label: enabled ? "Consolidate load to reduce drop frequency" : "-", value };
        case "bci":
            return { url: "/wlp?customer=" + selectedCustomerId, headingValue: "White Label Pricing", label: enabled ? `Increase price for in-house brand item for ${count} instances` : "-", value };
        default:
            return;
    }
};

const ServiceTableSingleRow = ({ count, enabled, opportunity, heading, selectedCustomerId, district, isFilterExpanded }: Props) => {
    const navigate = useNavigate()
    const headerStyle = {
        color: "black",
        border: "1px solid #bebebe",
        borderBottom: "3px solid #bebebe",
        backgroundColor: "white"
    };
    const columnStyle = {
        color: "black",
        borderRight: "0.1px solid #bebebe",
        borderBottom: "0.1px solid #bebebe",
        innerHeight: "36px",
    };
    const data = getData(heading, selectedCustomerId, count, opportunity, enabled, district)

    return (
        <TableContainer
            className={`${enabled && "table-container"}`}
            sx={{
                display: "flex",
                justifyContent: "center",
                overflow: "unset"
            }}
        >
            <Table
                sx={{
                    border: enabled ? "1px solid #79ac03" : "1px solid #ffffff",
                    width: "100%",
                    fontStyle: enabled ? "italic" : "none",
                    background: "white"
                }}
            >
                <TableHead>
                    <TableRow sx={{ backgroundColor: "#79ac03", }}>
                        <StyledTableCellData
                            className="alignCenter !p-[0.6vh] !font-bold"

                            sx={headerStyle}
                        >
                            {data?.headingValue}
                        </StyledTableCellData>
                        <StyledTableCellData
                            className="alignCenter !p-[0.6vh] !font-bold"
                            sx={headerStyle}
                        >
                            Oppty
                        </StyledTableCellData>
                    </TableRow>
                </TableHead>
                <TableBody >
                    <TableRow className={`even ${isFilterExpanded ? "h-[5vh]" : "h-[6vh]"}`} sx={{
                        cursor: enabled === true ? "pointer" : "",
                    }} onClick={() => {
                        enabled === true && data?.url ? navigate(data.url) : {}
                    }}>
                        <StyledTableCellData
                            className="!p-[0.6vh]"
                            width="80%"
                            sx={{
                                ...columnStyle,
                                textAlign: enabled ? "left" : "center"
                            }}

                        > {data?.label} </StyledTableCellData>
                        <StyledTableCellData className="!p-[0.6vh]" sx={{
                            textAlign: "center", ...columnStyle,
                        }} width="20%">
                            {data?.value}
                        </StyledTableCellData>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );

}

const StyledTableCellData = styled(TableCell)({
    lineHeight: 1.4,
    fontSize: "1.4vh",
    fontFamily:
        'BlinkMacSystemFont,-apple-system,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue","Helvetica","Arial",sans-serif',
    background: "none",
    padding: 0,
    paddingLeft: "2px !important",
    paddingRight: "2px !important",
    paddingTop: "2px !important",
    paddingBottom: "2px !important",
});

export default ServiceTableSingleRow